<template lang="pug">
.aerial-log.aerial-log--city
    template(v-if="load_data_status_aerial_log.status === 'loading'")
        Loading(show="true")

    template(v-else)
        .list-area(v-if="aerial_log.top_location && aerial_log.top_location.top_city && Object.keys(aerial_log.top_location.top_city).length > 0")
            .block(v-for="(city,index) in aerial_log.top_location.top_city" :key="index")
                .list-item.flex.items-center.justify-between.px-4.py-2
                    span.text-light {{ city.name }}
                    strong.monospace {{ city.counter }}
        NoDataAvailable(v-else)

</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'AerialCity',
    components: {
        Loading,
        NoDataAvailable,
    },
    data() {
        return {
            // 
        }
    },
    computed: {
        ...mapState([
            'load_data_status_aerial_log',
            'aerial_log',
        ]),
    },
    watch: {
        // 
    },
    methods: {
        // 
    },
    mounted() {
        // 
    },
}
</script>
